export default {
  id: 'paylocity',
  title: 'Paylocity Integration',
  category: 'Admin',
  summary: 'Map employees and import or schedule payroll data from Paylocity.',
  overview: 'Paylocity integration connects employee identity and payroll periods between Timeclerk and Paylocity. Accurate employee mapping is required before payroll imports are reliable.',
  howItWorks: [
    'Test the connection to confirm credentials and API access.',
    'Map Timeclerk employees to Paylocity employees.',
    'Use payroll capabilities to import or schedule payroll period data.',
    'Review imported payroll details in the Payroll admin area.'
  ],
  actions: [
    {
      name: 'Test connection',
      description: 'Verifies that Timeclerk can reach Paylocity with the configured credentials.'
    },
    {
      name: 'Map employees',
      description: 'Links each Timeclerk employee to the corresponding Paylocity employee record.'
    },
    {
      name: 'Import / schedule payroll',
      description: 'Pulls payroll period data into Timeclerk according to the selected schedule or manual import.'
    }
  ],
  tips: [
    'Unmapped employees are the most common cause of incomplete payroll imports.',
    'After hiring someone in both systems, map them before the next payroll run.'
  ],
  related: ['integrations', 'employees', 'payroll']
};



// WEBPACK FOOTER //
// ./client/help/content/paylocity.js